<template>
  <div
    data-testid="mention-list"
    class="font-regular flex flex-col rounded-md bg-gray-600 px-1 font-inter text-sm leading-6 shadow-md"
  >
    <template v-if="items.length">
      <button
        v-for="(item, index) in items"
        :key="index"
        data-testid="mention-list-item"
        class="flex items-center gap-2 rounded-sm bg-gray-600 px-2 py-1 text-gray-50 transition duration-300 hover:bg-gray-700"
        :class="{ '!bg-gray-800': index === selectedIndex }"
        @click="selectItem(index)"
      >
        {{ item.label }}
      </button>
    </template>
  </div>
</template>

<script lang="ts" setup>
  import { ref, watch } from "vue";
  const props = defineProps<{
    items: {
      value: string;
      label: string;
      text?: string;
    }[];
    command: (args: { value: string; label: string }) => void;
  }>();
  const selectedIndex = ref(0);
  watch(props.items, () => {
    selectedIndex.value = 0;
  });
  function onKeyDown({ event }: { event: KeyboardEvent }) {
    if (event.key === "ArrowUp") {
      upHandler();
      return true;
    }
    if (event.key === "ArrowDown") {
      downHandler();
      return true;
    }
    if (event.key === "Enter") {
      enterHandler();
      return true;
    }
    return false;
  }
  function upHandler() {
    selectedIndex.value =
      (selectedIndex.value + props.items.length - 1) % props.items.length;
  }
  function downHandler() {
    selectedIndex.value = (selectedIndex.value + 1) % props.items.length;
  }
  function enterHandler() {
    selectItem(selectedIndex.value);
  }
  function selectItem(index: number) {
    const item = props.items[index];
    if (item) {
      props.command(item);
    }
  }
  defineExpose({ onKeyDown });
</script>
